import { createSlice } from '@reduxjs/toolkit'
import {
    authenticatedFailureAction,
    authenticatedFinishAction,
    authenticatedSuccessAction,
    refreshTokenSucessAction,
    loginAction,
    logoffAction,
    updateTenantAction,
    switchTenantSuccessAction
} from './actions'

const INITIAL_STATE = {
    refreshToken: null,
    token: null,
    user: null,
    isLoggedIn: false,
    error: false,
    loading: false,
    selectedTenant: null
}

export const authSlice = createSlice({
    name: 'auth',
    initialState: INITIAL_STATE,
    reducers: {
        authenticatedFailure: authenticatedFailureAction,
        authenticatedFinish: authenticatedFinishAction,
        authenticatedSuccess: authenticatedSuccessAction,
        refreshTokenSucess: refreshTokenSucessAction,
        login: loginAction,
        logoff: logoffAction,
        updateTenant: updateTenantAction,
        switchTenantSuccess: switchTenantSuccessAction
    }
})

export const { authenticatedFinish, authenticatedSuccess, authenticatedFailure, refreshTokenSucess, login, logoff, updateTenant, switchTenantSuccess } = authSlice.actions

export default authSlice.reducer

export const useAuthTenant = state => state.auth.selectedTenant

export const useAuthLoggedIn = state => state.auth.isLoggedIn

export const useAuthUser = state => state.auth.user

export const useAuthLoading = state => state.auth.loading

export const useAuthError = state => state.auth.error

export const useAuthToken = state => state.auth.token

export const useAuthRefreshToken = state => state.auth.refreshToken